import { useState } from 'react'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { RetroButton } from '@/components/retro/RetroButton'
import { useToast } from '@/hooks/use-toast'
import { Loader2 } from 'lucide-react'

export const QuoteSection = () => {
  const { toast } = useToast()
  const [loading, setLoading] = useState(false)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
      toast({
        title: 'Solicitação Enviada!',
        description: 'Nossa equipe entrará em contato em breve.',
        className:
          'retro-bevel-outset bg-[#cccccc] font-serif border-2 border-gray-600',
      })
    }, 1500)
  }

  return (
    <div className="h-full flex flex-col animate-fade-in p-4 max-w-2xl mx-auto w-full">
      <h2 className="text-3xl font-serif font-bold text-gray-900 mb-6 border-b-2 border-gray-400 pb-2">
        Comprar Sucata (Cotação)
      </h2>

      <form
        onSubmit={handleSubmit}
        className="space-y-6 retro-bevel-outset p-8 bg-[#dcdcdc]"
      >
        <div className="grid gap-2">
          <label className="font-serif font-bold text-gray-800">
            Nome da Empresa / Pessoa:
          </label>
          <Input
            required
            className="retro-bevel-inset bg-white border-0 rounded-none h-10 font-serif"
            placeholder="Digite seu nome..."
          />
        </div>

        <div className="grid gap-2">
          <label className="font-serif font-bold text-gray-800">
            Telefone / WhatsApp:
          </label>
          <Input
            required
            type="tel"
            className="retro-bevel-inset bg-white border-0 rounded-none h-10 font-serif"
            placeholder="(00) 00000-0000"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="grid gap-2">
            <label className="font-serif font-bold text-gray-800">
              Material:
            </label>
            <Select>
              <SelectTrigger className="retro-bevel-outset bg-gray-100 border-0 rounded-none h-10 font-serif">
                <SelectValue placeholder="Selecione..." />
              </SelectTrigger>
              <SelectContent className="font-serif border-2 border-gray-600">
                <SelectItem value="ferro">Ferro</SelectItem>
                <SelectItem value="aluminio">Alumínio</SelectItem>
                <SelectItem value="cobre">Cobre</SelectItem>
                <SelectItem value="aco">Aço Inox</SelectItem>
                <SelectItem value="bateria">Baterias</SelectItem>
                <SelectItem value="outros">Outros</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="grid gap-2">
            <label className="font-serif font-bold text-gray-800">
              Peso Estimado (kg):
            </label>
            <Input
              type="number"
              className="retro-bevel-inset bg-white border-0 rounded-none h-10 font-serif"
              placeholder="Ex: 500"
            />
          </div>
        </div>

        <div className="grid gap-2">
          <label className="font-serif font-bold text-gray-800">
            Cidade / Região:
          </label>
          <Input
            required
            className="retro-bevel-inset bg-white border-0 rounded-none h-10 font-serif"
            placeholder="Ex: São Paulo, Zona Sul"
          />
        </div>

        <div className="pt-4 flex justify-end">
          <RetroButton
            variant="flat-3d"
            className="text-lg px-8 py-2 font-bold bg-gray-300"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" /> Enviando...
              </>
            ) : (
              'Solicitar Cotação'
            )}
          </RetroButton>
        </div>
      </form>
    </div>
  )
}
